var map = {
	"./company_Mil.svg": 4617,
	"./company_asahi.svg": 9516,
	"./company_bigcamera.svg": 4064,
	"./company_kurand.svg": 4691,
	"./company_kyodo.svg": 3457,
	"./company_mirai.svg": 3097,
	"./company_nexyz.svg": 1281,
	"./company_orbis.svg": 3366,
	"./company_pola.svg": 2941,
	"./company_shinagawa.svg": 6742,
	"./company_vector.svg": 1245,
	"./company_weblio.svg": 2050,
	"./company_xl.svg": 4635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8985;